export default {
  title: 'Double Your Gear',
  pathId: '',
  testShopifyId: 'gid://shopify/Product/7819193745497',
  prodShopifyId: 'gid://shopify/Product/8701921525996',
  description: 'Get an extra set of essentials—gloves, quick wraps, and ankle wraps—so you\'re always ready to train or share the workout.',
  shortDescription: 'Additional Pair of Boxing Gloves, Quick Wraps, and Ankle Wraps',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x960/9d724c684c/doubleyourgear.jpeg',
    alt: 'Extra set of gloves, quick wraps, and ankle wraps',
  },
  includes: [
    {
      productName: 'Gloves',
    },
    {
      productName: 'Quick Wraps',
    },
    {
      productName: 'Ankle Wraps',
    },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Gloves: Multi-layered foam padding, ventilated palms, and hook-and-loop wrist closure for secure, breathable comfort',
        'Quick Wraps: Built-in pocket for punch trackers, padded knuckles, and secure wrist wrap',
        'Ankle Wraps: Pocket for kick trackers, supportive fit that stays in place during movement',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Gloves: Available in 12oz and 16oz (based on height/weight)',
        'Quick & Ankle Wraps: Available in S/M and L/XL with stretchable fabric for a snug fit',
      ],
    },
    {
      title: 'Materials & Care',
      copy: [
        'Gloves: Premium leather; wipe clean with damp cloth',
        'Quick & Ankle Wraps: 80% polyester / 20% spandex; machine wash cold and tumble dry low',
      ],
    },
  ],
};
